module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADqSURBVHgBjZCxDgFBEIZn9kR9DyBylZpOSSeiuFdQklzwBHgCERGlR9AIOt7A1aqLeAAkFMvu2FkuEa64qWZm/29m/kVIEZ4/d5W87TkXaQAl73PmMA2Qq0/7AOQbcSS0UxW8zvNnXpI435h2EGjAuRbUjDatSPBtSqrtL8Q1kbZiAw1Py2D38YAhv7+hkRuLuQZCl4DGx1UwiAcJJyubfJ+FHtkRN59SLT4mw9Mq6H5vRjuxNvO0o/ZEYCZCaJrF2CTf/QfY32hMKqhxa5tIZ6EypV8xhxMn18M6cgv1ixGXiUTvuG7vICFekiJnaUJmOZAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_conci/ico-check-small.png
// module id = l4hO
// module chunks = 0